import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {initTheme} from './global/Theme';
import {isCordova} from './global/AppMode';

initTheme();


const renderReactDom = () => {
    ReactDOM.render(<App />, document.getElementById('root'));
};

if (window.cordova) {
    document.addEventListener('deviceready', () => {
        renderReactDom();
    }, false);
} else {
    renderReactDom();
}

// Web: vlastný service worker public/pwa-sw.js (scope celej domény) – vďaka nemu sa portál
// mandanta dá nainštalovať z prehliadača ako appka (manifest viď AppMode.applyAppManifest).
// CRA service worker sa nepoužíva (navigácie na PDF by presmeroval na index.html).
// Cordova a dev server (npm start - nehashované bundle.js) bez service workera.
if (process.env.NODE_ENV === 'production' && !isCordova() && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(process.env.PUBLIC_URL + '/pwa-sw.js').catch((error) => {
            console.warn('PWA service worker sa nepodarilo zaregistrovať', error);
        });
    });
} else {
    serviceWorker.unregister();
    if (!isCordova() && 'serviceWorker' in navigator) {
        // v dev režime odstrániť pwa-sw.js, ak ostal z testu produkčného buildu na tej istej adrese
        navigator.serviceWorker.getRegistrations().then((registrations) => registrations
            .filter((registration) => registration.active && registration.active.scriptURL.indexOf('/pwa-sw.js') >= 0)
            .forEach((registration) => registration.unregister()));
    }
}
